module.exports = global["I18n"] = require("-!./i18n.js");